import { z } from 'zod';

export const NestedOrderProductConfigurationSchema = z.object({
    orderProductId: z.string().uuid(),
    showZeroPurchasePrice: z.boolean(),
    showZeroSalesPrice: z.boolean(),
});
